import { Product } from "@domain/product/product";
import { GasWarningCenterConfiguration } from "@domain/project/configurations/gas-warning-center-configuration";
import { Regard3000Configuration } from "@domain/project/configurations/regard-3000-configuration";
import { OriginalRegard7000PlusConfiguration } from "@project/gas-warning-center-configuration/regard-7000-plus/original-regard-7000-plus-configuration";

export class OriginalGasWarningCenterConfiguration {
  productConfiguration?: GasWarningCenterConfiguration;
  gasWarningCenter?: Product;
  attachments?: { product: Product; quantity: number }[];
  regard3000Configuration?: Regard3000Configuration;
  regard7000PlusConfiguration?: OriginalRegard7000PlusConfiguration;

  constructor(
    productConfiguration: GasWarningCenterConfiguration,
    gasWarningCenter?: Product,
    attachments?: { product: Product; quantity: number }[],
    regard3000Configuration?: Regard3000Configuration,
    regard7000PlusConfiguration?: OriginalRegard7000PlusConfiguration,
  ) {
    this.productConfiguration = productConfiguration;
    this.gasWarningCenter = gasWarningCenter;
    this.attachments = attachments;
    this.regard3000Configuration = regard3000Configuration;
    this.regard7000PlusConfiguration = regard7000PlusConfiguration;
  }
}
